import React, { useEffect, useState } from 'react'

//MUI
import { Alert, AlertTitle, Box, Button, Card, CardContent, CardHeader, CardMedia, Container, Grid, IconButton, Menu, MenuItem, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';

//react-beatufil-dnd
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

//imagen  prueba
import web from '../../../Assets/Images/proxwebinar.png'

//router dom
import { useNavigate } from 'react-router-dom';


const Webinars = () => {
    const [data, setData] = useState([])
    const navigate = useNavigate()
    const [selectedIndex, setSelectedIndex] = useState(null)

    const handleNavigate = () => {
        navigate('/nin-admin/nuevo-webinar');
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event, index) => {
        setAnchorEl(event.currentTarget);
        setSelectedIndex(index)
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    //drag
    const handleDrag = (result) => {
        if (!result.destination) return;

        const arr = [...data];

        //Changing the position of Array element
        let removedItem = arr.splice(result.source.index, 1)[0];
        arr.splice(result.destination.index, 0, removedItem);

        //Updating the list
        setData(arr);
    };

    const handleDelete = (index) => {
        const confirmed = window.confirm('¿Estás seguro de que deseas eliminar este webinar?');
        if (!confirmed) return;

        const updatedForms = [...data];
        updatedForms.splice(index, 1);
        setData(updatedForms);
        localStorage.setItem('webi', JSON.stringify(updatedForms));
    };

    useEffect(() => {
        const savedForms = JSON.parse(localStorage.getItem('webi')) || [];
        setData(savedForms)
    }, []);

    const formatFecha = (dateString) => {
        const meses = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];

        const date = new Date(dateString);
        const day = date.getDate();
        const month = meses[date.getMonth()];
        const year = date.getFullYear();

        return `${day} de ${month} del ${year}`;
    };

    return (
        <>
            <Container maxWidth='xl' sx={{ mb: 5 }}>
                <Box display='flex' justifyContent='space-between' gap={2} flexWrap='wrap' mb={5}>
                    <Typography variant='h5' sx={{ fontWeight: '600', fontSize: '28px', color: '#004A86', my: 'auto' }}>Webinars</Typography>
                    <Button size='large' variant='contained' sx={{ textTransform: 'none', my: 'auto' }} endIcon={<AddIcon />} onClick={handleNavigate}>Añadir nuevo</Button>
                </Box>
                {
                    data.length > 0
                        ?
                        <DragDropContext onDragEnd={handleDrag}>
                            <Droppable droppableId="protocols">
                                {(provided) => (
                                    <Grid container spacing={3} {...provided.droppableProps} ref={provided.innerRef}>
                                        {
                                            data.map((res, index) => (
                                                <Draggable
                                                    key={index}
                                                    draggableId={index.toString()}
                                                    index={index}
                                                >
                                                    {(provided) => (
                                                        <Grid item xl={6} lg={6} md={12} sm={12} xs={12} sx={{ display: 'flex' }}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >

                                                            <Card sx={{ width: '100%' }}>
                                                                <CardHeader
                                                                    action={
                                                                        <IconButton onClick={(e) => handleClick(e, index)}>
                                                                            <MoreVertIcon />
                                                                        </IconButton>
                                                                    }
                                                                    title={
                                                                        <Typography variant='body1'>
                                                                            <span style={{ fontWeight: 'bold' }}>Ponente:</span> {res.speakerName}
                                                                        </Typography>
                                                                    }
                                                                    subheader={`${formatFecha(res.date)}, ${res.time} hrs CDMX`}
                                                                    subheaderTypographyProps={{ variant: 'body2' }}
                                                                />
                                                                <CardMedia
                                                                    component="img"
                                                                    height="250"
                                                                    image={web}
                                                                    alt="PortadaWebinar"
                                                                    sx={{
                                                                        objectFit: 'contain'
                                                                    }}
                                                                />
                                                                <CardContent>
                                                                    <Typography variant='h6' sx={{ color: '#000c77', fontWeight: 'bold' }}>
                                                                        Titulo del webinar:
                                                                    </Typography>
                                                                    <Typography variant='body1' color='text.secondary'>
                                                                        {res.title}
                                                                    </Typography>
                                                                </CardContent>
                                                            </Card>
                                                            <Menu
                                                                anchorEl={anchorEl}
                                                                open={open}
                                                                onClose={handleClose}
                                                            >
                                                                <MenuItem onClick={handleClose}>Editar</MenuItem>
                                                                <MenuItem
                                                                    onClick={() => {
                                                                        handleDelete(selectedIndex)
                                                                        handleClose()
                                                                    }}
                                                                >
                                                                    Eliminar
                                                                </MenuItem>
                                                            </Menu>
                                                        </Grid>
                                                    )}
                                                </Draggable>
                                            ))}
                                        {provided.placeholder}
                                    </Grid>
                                )}
                            </Droppable>
                        </DragDropContext>
                        :
                        <Alert severity="info">
                            <AlertTitle>Sin resultados</AlertTitle>
                            No hay ningún elemento guardado para los webinars próximos.
                        </Alert>
                }

            </Container>
        </>
    )
}

export default Webinars